<div class="users-list-container">
  <div class="search-bar">
    <div class="search-input-wrapper">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        type="text"
        placeholder="Search users"
        [formControl]="form.controls.searchText"
      />
    </div>
  </div>

  <!-- TABLE CARD WRAPPER -->
  <div class="table-card" #tableCard>
    <!-- Actual table -->
    <!-- Added by amisha on 2026-04-30 -->
    <!-- Reason: keep searchText and other list query params when the inline close icon collapses the row. -->
    <wm-common-table
      *ngIf="hasSearched"
      [columns]="columns"
      [data]="filtered"
      [isLoading]="isSearching"
      tableType="Staff"
      [serverSidePagination]="true"
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [pageSize]="pageSize"
      (pageChange)="onPageChange($event)"
      expansionMode="inline"
      expandOn="cell"
      [preserveEditQueryParamOnCollapse]="true"
      [expandedComponent]="UserSettingsJanusComponent"
      [expandedComponentInputs]="getUserSettingsInputs"
      (sortChanged)="onSortChange($event)"
      [showRowsPerPage]="true"
      [showTotalRecords]="true"
      [totalRecords]="allUsers.length"
      [pageSizeStorageKey]="'users-list-janus'"
      (rowsPerPageChange)="onRowsPerPageChange($event)"
    >
    </wm-common-table>
  </div>
</div>
